export const ADMIN_GET_USERS_REQUEST = 'ADMIN_GET_USERS_REQUEST';
export const ADMIN_GET_USERS_SUCCESS = 'ADMIN_GET_USERS_SUCCESS';
export const ADMIN_GET_USERS_ERROR = 'ADMIN_GET_USERS_ERROR';

export const ADMIN_GET_PROVIDERS_REQUEST = 'ADMIN_GET_PROVIDERS_REQUEST';
export const ADMIN_GET_PROVIDERS_SUCCESS = 'ADMIN_GET_PROVIDERS_SUCCESS';
export const ADMIN_GET_PROVIDERS_ERROR = 'ADMIN_GET_PROVIDERS_ERROR';

export const ADMIN_GET_USERTYPES_REQUEST = 'ADMIN_GET_USERTYPES_REQUEST';
export const ADMIN_GET_USERTYPES_SUCCESS = 'ADMIN_GET_USERTYPES_SUCCESS';
export const ADMIN_GET_USERTYPES_ERROR= 'ADMIN_GET_USERTYPES_ERROR';

export const ADMIN_ADD_USERTYPE_REQUEST = 'ADMIN_ADD_USERTYPE_REQUEST';
export const ADMIN_ADD_USERTYPE_SUCCESS = 'ADMIN_ADD_USERTYPE_SUCCESS';
export const ADMIN_ADD_USERTYPE_ERROR= 'ADMIN_ADD_USERTYPE_ERROR';

export const ADMIN_DELETE_USER_REQUEST = 'ADMIN_DELETE_USER_REQUEST';
export const ADMIN_DELETE_USER_SUCCESS = 'ADMIN_DELETE_USER_SUCCESS';
export const ADMIN_DELETE_USER_ERROR = 'ADMIN_DELETE_USER_ERROR';

export const ADMIN_USER_UPDATE_TAGS_REQUEST = 'ADMIN_USER_UPDATE_TAGS_REQUEST';
export const ADMIN_USER_UPDATE_TAGS_SUCCESS = 'ADMIN_USER_UPDATE_TAGS_SUCCESS';
export const ADMIN_USER_UPDATE_TAGS_ERROR = 'ADMIN_USER_UPDATE_TAGS_ERROR';

export const ADMIN_USER_UPDATE_COMPANIES_REQUEST = 'ADMIN_USER_UPDATE_COMPANIES_REQUEST';
export const ADMIN_USER_UPDATE_COMPANIES_SUCCESS = 'ADMIN_USER_UPDATE_COMPANIES_SUCCESS';
export const ADMIN_USER_UPDATE_COMPANIES_ERROR = 'ADMIN_USER_UPDATE_COMPANIES_ERROR';

export const ADMIN_USER_UPDATE_RESULTLINK_REQUEST = 'ADMIN_USER_UPDATE_RESULTLINK_REQUEST';
export const ADMIN_USER_UPDATE_RESULTLINK_SUCCESS = 'ADMIN_USER_UPDATE_RESULTLINK_SUCCESS';
export const ADMIN_USER_UPDATE_RESULTLINK_ERROR = 'ADMIN_USER_UPDATE_RESULTLINK_ERROR';

export const ADMIN_USER_DETAIL_REQUEST = 'ADMIN_USER_DETAIL_REQUEST';
export const ADMIN_USER_DETAIL_SUCCESS = 'ADMIN_USER_DETAIL_SUCCESS';
export const ADMIN_USER_DETAIL_ERROR = 'ADMIN_USER_DETAIL_ERROR';
